<template>
<div class="chapter">
<div class="inner_page">
<h1 class="preface-title2"><a href="#/toc#toc-preface005">THESIGER FAMILY (1722-2005)</a></h1>
<p class="imga"><a id="pagexiv"></a><a id="pagexv"></a><img alt="image" src="images/Art_xiv.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface005.vue?59580b75